import React, { Component } from "react";
import styled, { ThemeProvider } from "styled-components";
import { Route, Router, Switch } from "react-router-dom";

// Styles //
import GlobalStyles from "styles/global";
import theme from "styles/theme";

// Utils //
import history from "utils/history";

// Screens //
import GettingStarted from "screens/GettingStarted";
import Welcome from 'screens/Welcome';

// Components //
import View from 'components/View';

const Root = styled(View)`
  min-height: 100%;
  margin: 0 auto;
  padding: 0px;
  background-color: ${ ({ theme }) => theme.color.light };
  flex: 1;
`;

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Root>
          <Router history={history}>
            <Switch>
              <Route
                path="/:step"
                component={GettingStarted}
              />
              <Route
                path="/"
                component={Welcome}
              />
            </Switch>
          </Router>
          <GlobalStyles />
        </Root>
      </ThemeProvider>
    );
  }
}

export default App;
